// Map old ?navigation=X query params to new paths for backwards compatibility
const LEGACY_NAV_MAP = {
  'Lobbies': '/lobbies',
  'UserSearch': '/user-search',
  'DriverPayments': '/driver-payments',
  'ChatBroadcast': '/chat-broadcast',
  'NewsPopup': '/news-popup',
  'Coupons': '/coupons',
  'ImportCohort': '/import-cohort',
  'CRMUsers': '/crm-users',
  'Influencers': '/influencers',
  'Pricing': '/pricing',
  'Discounts': '/discounts',
  'Liquidity': '/liquidity',
  'LiveDashboard': '/live',
  'PayoutReview': '/payout-review'
}

const ROUTE_TITLES = {
  '/lobbies': 'Lobbies',
  '/user-search': 'Buscar Usuario',
  '/driver-payments': 'Pagos Pendientes',
  '/chat-broadcast': 'Chat Broadcast',
  '/news-popup': 'Popup de Noticias',
  '/coupons': 'Cupones',
  '/import-cohort': 'Importar Cohort',
  '/crm-users': 'CRM',
  '/influencers': 'Influencers',
  '/pricing': 'Precios',
  '/discounts': 'Descuentos',
  '/liquidity': 'Liquidity',
  '/live': 'En Vivo',
  '/payout-review': 'Revisión de payouts'
}

export function getLegacyRedirectPath() {
  const params = new URLSearchParams(window.location.search)
  const navigation = params.get('navigation')
  if (navigation && LEGACY_NAV_MAP[navigation]) {
    const userId = params.get('user_id')
    let path = LEGACY_NAV_MAP[navigation]
    if (userId && navigation === 'UserSearch') {
      path += `?user_id=${encodeURIComponent(userId)}`
    }
    return path
  }
  return null
}

export function getRouteTitle(pathname) {
  return ROUTE_TITLES[pathname] || ''
}
